import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const FichasController = {
    async ListFichas() {
        try {
          const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`fichas_page/list_audits_active`, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data.result;
        } catch (error) {
          console.error("Error fetching transcripts:", error);
          throw error;
        }
    },
    async ListFichasByID(Id) {
      try {
        const response = await axios.get(
          `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/get_form_data_or_edit/${Id}`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        return response.data.result[0];
      } catch (error) {
        console.error("Error updating user:", error);
        throw error;
      }
    },  
    async ShowContext(Id) {
      try {
        const response = await axios.get(
          `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/show_context/${Id}`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        return response.data.result[0];
      } catch (error) {
        console.error("Error updating user:", error);
        throw error;
      }
    },  
    async AddFichas(newNome,selectedCampanha,selectedOperation,selectedCampanhaId) {
        try {
          const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `fichas_page/add_audits`, {
            Nome: newNome,
            Campanha_Nome: selectedCampanha,
            Operacao_Descricao: selectedOperation,
            Campanha_Id: selectedCampanhaId,
          }, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data;
        } catch (error) {
          console.error("Error creating user:", error);
          throw error;
        }
      },
    async DuplicateFicha(newAudit) {
        try {
          const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `fichas_page/clone_audit`, 
            newAudit, 
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            });

          return response.data;
        } catch (error) {
          console.error("Error duplicating :", error);
          throw error;
        }
      },
      async PutFichas(Id, Nome) {
        try {
          const response = await axios.put(
            `${AppConfig.BACKEND_URL_REFATORADO}perguntas_page/get_form_data_or_edit/${Id}`,
            { Nome },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error updating user:", error);
          throw error;
        }
      },  
      async DeleteFichas(Id) {
        try {
          const response = await axios.delete(
            `${AppConfig.BACKEND_URL_REFATORADO}fichas_page/inactive_audit/${Id}`, 
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error deleting user:", error);
          throw error;
        }
      },
};

export default FichasController;